const StylizedTheme = (props) => {
    return props.children
};

export default StylizedTheme;
